<!-- <h4>{{ chartTitle }}</h4> -->
<!-- <button (click)="expand()">Enlarge</button> -->

<sf-card [cardTitle]="chartTitle">
    <apx-chart
        #chartspark
        [series]="getChartData().series!"
        [chart]="getChartData().chart!"
        [labels]="getChartData().labels!"></apx-chart>
</sf-card>
